import { render, staticRenderFns } from "./EhrMakePage.vue?vue&type=template&id=5a62d6b5"
import script from "./EhrMakePage.vue?vue&type=script&lang=js"
export * from "./EhrMakePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports